window.addEventListener("DOMContentLoaded", function () {
  /*
   * [Bundle] -> Global variables
   */

  const productSelectors = document.querySelectorAll(
    "[data-bundle_product_selector]"
  );
  const sellingPlanSelectors = document.querySelectorAll(
    "[data-bundle_selling_plan_selector]"
  );
  const productForm = document.querySelector("form.ProductForm");
  const cartItemList = document.querySelector(".Cart__ItemList");

  const selectedProducts = new Array(productSelectors.length).fill(null);
  const selectedSellingPlan = { group: null, options: null };

  if (
    productSelectors &&
    productSelectors.length &&
    sellingPlanSelectors &&
    sellingPlanSelectors.length &&
    productForm
  ) {
    handleBundleProductForm(productForm);
    productSelectors.forEach(initBundleProductSelector);
    sellingPlanSelectors.forEach(initBundleSellingPlanSelector);
  }
  if (cartItemList) {
    handleCartBundleActions(cartItemList);
  }

  /*
   * [Bundle] -> Product selector utilities
   */

  function initBundleProductSelector(selector, selectorIndex) {
    const productList = selector.querySelector("[data-bundle_product_list]");
    const productItems = productList.querySelectorAll(
      "[data-bundle_product_item]"
    );
    const variantContainer = selector.querySelector(
      "[data-bundle_variant_container]"
    );
    productList.addEventListener(
      "BundleProductSelectorChange",
      async function (event) {
        if (
          !event.detail ||
          !event.detail.options ||
          !event.detail.options.length
        )
          return;
        const select = event.detail;
        variantContainer.innerHTML = "";
        if (!select.value) {
          setSelectedProduct(false, selectorIndex);
          toggleBundleAddtoCartButton(productForm);
          return;
        }

        selector.classList.toggle("bundle_loading");
        select.disabled = true;
        const variantSelector = await getVariantSelector(select.value);
        variantContainer.appendChild(variantSelector);
        selector.classList.toggle("bundle_loading");
        select.disabled = false;

        const sellingPlansByGroup = getSellingPlansFromProduct(variantSelector);
        const variantData = {
          id: variantSelector.dataset.bundle_variant_selector,
          raw_price: variantSelector.dataset.raw_price,
          selling_plans: sellingPlansByGroup,
        };
        setSelectedProduct(variantData, selectorIndex);
        checkProductsInBundle();
      }
    );
  }

  async function attemptFetch(
    url,
    options = { method: "get" },
    attempts = 3,
    status = {}
  ) {
    if (attempts === 0) {
      console.error(
        "Error on bundle variant selector (fetching): ",
        status.code,
        status.text
      );
      return false;
    }
    const promise = await fetch(url, options);
    if (!promise.ok)
      return await attemptFetch(url, options, attempts - 1, {
        code: promise.status,
        text: promise.statusText,
      });
    return promise;
  }

  async function getVariantSelector(product) {
    const url = `${window.Shopify.routes.root}products/${product}?section_id=rdh-bundle-variant-selector`;
    const promise = await attemptFetch(url);
    if (!promise) return false;
    const html = await promise.text();
    if (!html) return false;
    const temp = document.createElement("div");
    temp.innerHTML = html;
    const variantSelector = temp.querySelector(
      "[data-bundle_variant_selector]"
    );
    return variantSelector;
  }

  function initBundleVariantSelector(selector, selectorIndex, sellingPlans) {
    const variantList = selector.querySelector("[data-bundle_variant_list]");
    const variantItems = variantList.querySelectorAll(
      "[data-bundle_variant_item]"
    );

    variantItems.forEach((item) => {
      item.addEventListener("click", function () {
        if (
          selector.dataset.bundle_variant_selector ===
          item.dataset.bundle_variant_item
        )
          return;
        const variantData = {
          id: item.dataset.bundle_variant_item,
          raw_price: item.dataset.raw_price,
          selling_plans: sellingPlans,
        };
        selector.dataset.bundle_variant_selector = variantData.id;
        selector.dataset.raw_price = variantData.raw_price;
        setSelectedProduct(variantData, selectorIndex);
        checkProductsInBundle();
      });
    });
  }

  function getSellingPlansFromProduct(variantSelector) {
    const wrapper = variantSelector.querySelector(
      "[data-product_selling_plans]"
    );
    const planGroups = wrapper.querySelectorAll("[data-selling_plan_group]");
    const sellingPlansByGroup = {};
    planGroups.forEach((group) => {
      const sellingPlans = group.querySelectorAll("[data-selling_plan]");
      const sellingPlansData = [];
      sellingPlans.forEach((plan) => {
        const planOptions = plan.querySelectorAll("[data-value]");
        const optionsData = {};
        planOptions.forEach((option) => {
          optionsData[option.dataset.handle] = {
            label: option.dataset.name,
            value: {
              label: option.dataset.value,
              handle: option.dataset.value_handle,
            },
          };
        });
        const planData = {
          id: plan.dataset.selling_plan,
          price_adjustment: {
            type: plan.dataset.adjustment_type,
            value: Number(plan.dataset.price_adjustment),
          },
          options: optionsData,
        };
        sellingPlansData.push(planData);
      });
      sellingPlansByGroup[group.dataset.plan_group_handle] = {
        label: group.dataset.selling_plan_group,
        selling_plans: sellingPlansData,
      };
    });

    wrapper.parentElement.removeChild(wrapper);
    return sellingPlansByGroup;
  }

  function setSelectedProduct(variant, index) {
    const isValid =
      variant &&
      variant.hasOwnProperty("id") &&
      variant.hasOwnProperty("raw_price") &&
      variant.hasOwnProperty("selling_plans");
    const variantData = isValid
      ? {
          id: variant.id,
          price: variant.raw_price,
          selling_plans_by_group: variant.selling_plans,
        }
      : null;
    selectedProducts.splice(index, 1, variantData);
  }

  function checkProductsInBundle() {
    const productsInBundle = selectedProducts.filter(
      (product) => product !== null
    );
    if (productsInBundle.length != selectedProducts.length) return;
    //handleBundleSellingPlanSelectors();
    toggleBundleAddtoCartButton(productForm, true);
  }

  /*
   * [Bundle] -> Selling plan selector utilities
   */

  function handleBundleSellingPlanSelectors() {
    sellingPlanSelectors.forEach((selector) =>
      selector.removeAttribute("style")
    );
  }

  function initBundleSellingPlanSelector(selector) {
    const sellingPlanGroups = selector.querySelectorAll(
      "[data-selling_plan_group]"
    );
    if (!sellingPlanGroups || !sellingPlanGroups.length) return;
    sellingPlanGroups.forEach((group) =>
      initBundleSellingPlanGroup(selector, group)
    );
  }

  function initBundleSellingPlanGroup(selector, group) {
    const groupId = group.dataset.selling_plan_group;
    group.addEventListener("click", function () {
      if (group.dataset.hasOwnProperty("selected")) return;
      setSelectedGroup(group, selector);
      const selectedOptions = getSelectedSellingPlanGroupOptions(
        groupId,
        selector
      );
      const groupData = selectedOptions.length
        ? {
            label: group.dataset.group_name,
            handle: group.dataset.group_handle,
          }
        : null;
      setSelectedSellingPlan(groupData, selectedOptions);
    });
    const groupOptions = selector.querySelectorAll(
      `[data-group_options='${groupId}']`
    );
    groupOptions.forEach((option) =>
      initBundleSellingPlanGroupOptions(selector, group, option)
    );
  }

  function setSelectedGroup(group, selector) {
    const current = selector.querySelector(
      "[data-selling_plan_group][data-selected]"
    );
    if (current)
      toggleGroupContent(current.dataset.selling_plan_group, selector);
    current.removeAttribute("data-selected");
    group.dataset.selected = true;
    toggleGroupContent(group.dataset.selling_plan_group, selector);
  }

  function toggleGroupContent(id, selector) {
    const groupContent = selector.querySelector(`[data-group_content='${id}']`);
    if (!groupContent) return;
    const hiddenClass = groupContent.dataset.toggle_class;
    groupContent.classList.toggle(hiddenClass);
  }

  function initBundleSellingPlanGroupOptions(selector, group, option) {
    const groupId = group.dataset.selling_plan_group;
    const optionValues = option.querySelectorAll("[data-group_option_value]");
    optionValues.forEach((value) => {
      value.addEventListener("click", function () {
        if (value.dataset.hasOwnProperty("selected")) return false;
        const optionValue = setSelectedValue(value, option);
        if (!optionValue) return;
        const selectedOptions = getSelectedSellingPlanGroupOptions(
          groupId,
          selector
        );
        const groupData = selectedOptions.length
          ? {
              group: group.dataset.group_name,
              handle: group.dataset.group_handle,
            }
          : null;
        setSelectedSellingPlan(groupData, selectedOptions);
      });
    });
  }

  function setSelectedValue(value, option) {
    const current = option.querySelector(
      "[data-group_option_value][data-selected]"
    );
    current.removeAttribute("data-selected");
    value.dataset.selected = true;
    option.dataset.options_value = value.dataset.group_option_value;
    option.dataset.options_value_handle =
      value.dataset.group_option_value_handle;
    return value.dataset.group_option_value;
  }

  function getSelectedSellingPlanGroupOptions(groupId, selector) {
    const selectedOptions = [];
    const sellingPlanGroupOptions = selector.querySelectorAll(
      `[data-group_options='${groupId}']`
    );
    sellingPlanGroupOptions.forEach((option) => {
      const selectedOption = {
        name: {
          label: option.dataset.options_name,
          handle: option.dataset.options_handle,
        },
        value: {
          label: option.dataset.options_value,
          handle: option.dataset.options_value_handle,
        },
      };
      selectedOptions.push(selectedOption);
    });
    return selectedOptions;
  }

  function setSelectedSellingPlan(group, options) {
    selectedSellingPlan.group = group;
    selectedSellingPlan.options = options;
  }

  /*
   * [Bundle] -> Shopping cart utilities
   */

  function handleBundleProductForm(form) {
    toggleBundleAddtoCartButton(form);

    const wrapperProduct = form.querySelector("[data-bundle_wrapper_product]");
    const cartUrl = new URL(window.location.href);
    cartUrl.pathname = wrapperProduct.dataset.cart_url;
    cartUrl.search = "";

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      toggleBundleAddtoCartButton(form);
      const currentBundleItems = await getCurrentBundleItems();
      let bundleId = 0;
      currentBundleItems.forEach((bundle) => {
        if (bundle.id > bundleId) bundleId = bundle.id;
      });
      bundleId += 1;

      const bundle = getBundleItems(form, bundleId);
      if (!bundle.items.length) return;
      const addedBundleItems = await addBundleToCart(bundle.items);
      if (!addedBundleItems) {
        toggleBundleAddtoCartButton(form, true);
        return;
      }
      window.location.assign(cartUrl);
    });
  }

  function toggleBundleAddtoCartButton(form, isBundleReady = false) {
    const addToCartButton = form.querySelector("button.ProductForm__AddToCart");
    addToCartButton.disabled = !isBundleReady;
    addToCartButton.style.opacity = "0.5";
    if (isBundleReady) addToCartButton.removeAttribute("style");
  }

  function getBundleItems(form, bundleId) {
    const wrapperProduct = form.querySelector("[data-bundle_wrapper_product]");
    const wrapperVariant = form.querySelector("input[name='id']");
    const wrapperQuantity = form.querySelector("input[name='quantity']");
    const bundleQuantity = Number(wrapperQuantity.value);
    const itemQuantity = 1;
    const bundle = {
      wrapper: {
        product_id: wrapperProduct.dataset.product_id,
        variant_id: wrapperVariant.value,
        quantity: bundleQuantity,
      },
      items: [],
    };

    selectedProducts.forEach((product) => {
      const foundItemIndex = bundle.items.findIndex(
        (item) => item.id === product.id
      );
      if (foundItemIndex > -1) {
        bundle.items[foundItemIndex].quantity += itemQuantity * bundleQuantity;
        bundle.items[foundItemIndex].properties["units_per_bundle"] +=
          itemQuantity;
        return;
      }
      const item = {
        id: product.id,
        quantity: itemQuantity * bundleQuantity,
        properties: {
          bundle: wrapperProduct.dataset.product_title,
          bundle_id: bundleId,
          bundle_quantity: bundleQuantity,
          units_per_bundle: itemQuantity,
        },
      };
      if (
        selectedSellingPlan.group === null ||
        selectedSellingPlan.options === null ||
        !selectedSellingPlan.options.length
      ) {
        bundle.items.push(item);
        return;
      }
      const productSellingPlan = product.selling_plans_by_group[
        selectedSellingPlan.group.handle
      ].selling_plans.find((plan) => {
        const matchedOptions = selectedSellingPlan.options.filter((option) => {
          if (!plan.options.hasOwnProperty(option.name.handle)) return false;
          return (
            plan.options[option.name.handle].value.handle == option.value.handle
          );
        });
        return matchedOptions.length === selectedSellingPlan.options.length;
      });
      if (productSellingPlan) item.selling_plan = productSellingPlan.id;
      bundle.items.push(item);
    });

    return bundle;
  }

  async function addBundleToCart(items) {
    const url = `${window.Shopify.routes.root}cart/add.js`;
    const promise = await attemptFetch(url, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: items }),
    });
    if (!promise) return false;
    const data = await promise.json();
    if (!data) return false;

    return data;
  }

  async function getCurrentBundleItems() {
    const currentCart = await getCurrentCart();
    if (currentCart.item_count == 0) return [];
    const bundleItems = [];
    currentCart.items.forEach((item) => {
      if (
        !item.hasOwnProperty("properties") ||
        !item.properties.hasOwnProperty("bundle")
      )
        return;
      const foundBundleIndex = bundleItems.findIndex(
        (bundle) =>
          bundle.name.toLowerCase() === item.properties.bundle.toLowerCase() &&
          bundle.id === item.properties.bundle_id
      );
      const bundle =
        foundBundleIndex > -1
          ? bundleItems[foundBundleIndex]
          : {
              name: item.properties.bundle,
              id: item.properties.bundle_id,
              quantity: item.properties.bundle_quantity,
              items: [],
            };

      const bundleItem = {
        id: item.variant_id,
        key: item.key,
        quantity: item.quantity,
        properties: {
          bundle: item.properties.bundle,
          bundle_id: item.properties.bundle_id,
          bundle_quantity: item.properties.bundle_quantity,
          units_per_bundle: item.properties.units_per_bundle,
        },
      };
      if (item.hasOwnProperty("selling_plan_allocation"))
        bundleItem.selling_plan = item.selling_plan_allocation.selling_plan.id;
      bundle.items.push(bundleItem);
      if (foundBundleIndex < 0) bundleItems.push(bundle);
    });

    return bundleItems;
  }

  async function getCurrentCart() {
    const url = `${window.Shopify.routes.root}cart.js`;
    const promise = await attemptFetch(url, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!promise) return false;
    const data = await promise.json();
    if (!data) return false;

    return data;
  }

  async function handleCartBundleActions(itemList) {
    const currentBundleItems = await getCurrentBundleItems();
    document.body.addEventListener("CartItemQuantityChange", function (event) {
      if (
        !event.detail ||
        !event.detail.dataset ||
        !event.detail.dataset.hasOwnProperty("line_item_key")
      )
        return;
      handleCartBundleSelector(currentBundleItems, event.detail);
    });
  }

  async function handleCartBundleSelector(bundles, selector) {
    selector.disabled = true;
    selector.style.opacity = "0.5";
    selector.style.cursor = "wait";

    const bundle = findBundleFromSelector(
      bundles,
      selector.dataset.line_item_key
    );
    if (!bundle) return;
    const method = selector.dataset.bundle_quantity_button;
    const bundleNewQuantity =
      method === "add"
        ? bundle.quantity + 1
        : method === "sub"
        ? bundle.quantity - 1
        : 0;

    const itemsToClear = getCartBundleItemsToClear(bundle);
    const adjustedItems = getCartBundleAdjustedItems(bundle, bundleNewQuantity);

    const cartWithoutBundle = await removeBundleFromCart(itemsToClear);
    if (!cartWithoutBundle) return;
    if (bundleNewQuantity > 0) await addBundleToCart(adjustedItems);

    window.location.reload();
  }

  function findBundleFromSelector(bundles, itemKey) {
    const targetBundle = bundles.find((bundle) => {
      return bundle.items.some((item) => item.key == itemKey);
    });
    return targetBundle;
  }

  function getCartBundleAdjustedItems(bundle, quantity) {
    const bundleAdjustedItems = [];
    bundle.items.forEach((item) => {
      const adjustedItem = {
        id: item.id,
        quantity: item.properties.units_per_bundle * quantity,
        properties: {
          bundle: bundle.name,
          bundle_id: bundle.id,
          bundle_quantity: quantity,
          units_per_bundle: item.properties.units_per_bundle,
        },
      };
      if (item.hasOwnProperty("selling_plan"))
        adjustedItem.selling_plan = item.selling_plan;
      bundleAdjustedItems.push(adjustedItem);
    });

    return bundleAdjustedItems;
  }

  function getCartBundleItemsToClear(bundle) {
    const itemsToClear = {};
    bundle.items.forEach((item) => (itemsToClear[item.key] = 0));

    return itemsToClear;
  }

  async function removeBundleFromCart(items) {
    const url = `${window.Shopify.routes.root}cart/update.js`;
    const promise = await attemptFetch(url, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: items }),
    });
    if (!promise) return false;
    const data = await promise.json();
    if (!data) return false;

    return data;
  }
});
